

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import { TablesContext } from '../../context/table/TableContext';
import Message from '../../components/ui/Message';
import { useRequiredFields } from '../../hooks/useRequiredFields';




export const TablePage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const { sections, addTable, updateTable } = useContext(TablesContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');
    const [sectionId, setSectionId] = useState(-1);


    var table;

    if (state) {
        table = state.table;
    } else {
        table = {
            id: -1,
            name: ''
        }
    }


    const { formState, onInputChange } = useForm(table);

    var { id, name } = formState

    useEffect(() => {
        if (state) {
            setSectionId(table.section.id);
        }
    }, []);

    const handleSave = async () => {
        const formValid = name.length > 0;

        if (!formValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos");
            return;
        }

        formState.sectionId = sectionId;

        var resp = "";
        if (id > 0) {
            resp = await updateTable(formState);
        } else {
            resp = await addTable(formState);
        }
        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Mesa actualizada correctamente" : "Mesa creada correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{id > 0 ? 'Actualizar mesa' : 'Crear mesa'}</h3>
                <hr />

                <form className="row g-3 " >



                    <div className="mb-3">
                        <label htmlFor="tableNameInput" className="form-label">Nombre *</label>
                        <input
                            id='tableNameInput'
                            type="text"
                            className={`form-control${required.mark(!name)}`}
                            placeholder="Nombre mesa"
                            name="name"
                            value={name}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="sectionSelect" className="form-label">Sección</label>
                        <select id='sectionSelect' className="form-select" name='sectionId' value={sectionId} onChange={(e) => setSectionId(parseInt(e.target.value))}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {sections.length > 0
                                ?
                                sections.map(section => (
                                    <option key={section.id} value={section.id} >{section.name}</option>
                                ))
                                :
                                <option selected>No hay secciones configuradas</option>
                            }
                        </select>
                    </div>



                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
